export default "__VITE_ASSET__Bud4vPwg__"